module.exports = __webpack_public_path__ + "static/img/whzn.a5887ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/whzn.png
// module id = A9gp
// module chunks = 0